import React from "react";
import "./submitLoadingsmall.css";

const SubmitLoadingSmall = () => {
  return (
    <div className="SubmitLoadingSmall">
      <div className="loader">
        <div className="spin"></div>
        <div className="bounce"></div>
      </div>
    </div>
  );
};

export default SubmitLoadingSmall;
